export interface IAppNotificationUserEvent {
    id?: number;
    userId: string;
    appId: string;
    eventId: number;
    groupId?: number;
    isEmailSubscribed?: boolean;
    isInAppSubscribed?: boolean;
    isPushSubscribed?: boolean;
    isSmsSubscribed?: boolean;
    // helper property
    isModified?: boolean;
}

export class AppNotificationUserEvent implements IAppNotificationUserEvent {

    id?: number;
    userId: string;
    appId: string;
    eventId: number;
    groupId?: number;
    isEmailSubscribed = false;
    isInAppSubscribed = false;
    isPushSubscribed = false;
    isSmsSubscribed = false;
    isModified?: boolean;

    constructor(data: IAppNotificationUserEvent) {
        if (data.id) {
            this.id = data.id;
        }
        if (data.groupId) {
            this.groupId = data.groupId;
        }
        this.isModified = false;
        this.userId = data.userId;
        this.appId = data.appId;
        this.eventId = data.eventId;
        if (typeof data.isEmailSubscribed === 'boolean') {
            this.isEmailSubscribed = data.isEmailSubscribed;
        }
        if (typeof data.isInAppSubscribed === 'boolean') {
            this.isInAppSubscribed = data.isInAppSubscribed;
        }
        if (typeof data.isPushSubscribed === 'boolean') {
            this.isPushSubscribed = data.isPushSubscribed;
        }
        if (typeof data.isSmsSubscribed === 'boolean') {
            this.isSmsSubscribed = data.isSmsSubscribed;
        }
        if (typeof data.isModified === 'boolean') {
            this.isModified = data.isModified;
        }
    }

    getValue(): IAppNotificationUserEvent {
        const value = Object.assign({}, this);
        if (typeof value.isModified !== 'undefined') { delete value.isModified; }
        return value;
    }
}

